exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".SearchField_loader__tRgOe {\n  display: -webkit-flex;\n  display: flex;\n  -webkit-align-items: center;\n          align-items: center;\n  -webkit-justify-content: center;\n          justify-content: center;\n  width: 100%;\n  height: 100%; }\n", ""]);

// exports
exports.locals = {
	"loader": "SearchField_loader__tRgOe"
};